import { render, staticRenderFns } from "./yandex.vue?vue&type=template&id=28e2d259&scoped=true&"
import script from "./yandex.vue?vue&type=script&lang=js&"
export * from "./yandex.vue?vue&type=script&lang=js&"
import style0 from "./yandex.vue?vue&type=style&index=0&id=28e2d259&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e2d259",
  null
  
)

export default component.exports